import { naBridge, jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { generateUUID } from '../services/stat'
import { setKey, getKey, isAndroid, isIOS } from '../assets/utils'
import router from '../router'


router.afterEach((to, from) => {
  naBridge('goBack', () => {
    return false
  })
})

// 注：统一在这里注册js方法，请勿在其他地方注册
// naBridge('goBack', () => {
//     const vm = new Vue({})
//     vm.$bus.$emit('nativeBack')
//     vm.$destroy()
//     return true
// })

if (hasNativeMethod('showToolbar')) {
  jsBridge('showToolbar', {
    show: false,
    title: '天美贷'
  })
}

// 确认native注入成功，保存注入状态和状态栏高度
const initJsBridge = async (store, fn) => {
  if (hasNativeMethod('injectSuccess')) {
    const res = await jsBridge('injectSuccess')
    await saveUserInfo()
    store.dispatch('user/getIRR24')
    if (res && res.code === 'OK') {
      store.replaceState({
        ...store.state,
        hasJsBridge: true,
        statusBarHeight: res.data.height
      })
      setKey('jsBridge', {
        hasJsBridge: true,
        statusBarHeight: res.data.height
      })
    }
    fn()
  } else {
    fn()
  }
}

const saveUserInfo = async () => {
  const res = await jsBridge('getUserInfo')
  if (!res.data) return
  // 从其他平台过来的用户信息
  const userInfo = {
    token: res.data.t,
    mobile: res.data.m,
    wu: true,
    time: Date.now(),
    name: res.data.name
  }
  // 强制改变UUID
  generateUUID(res.data.uuid)
  // 设置系统版本
  setKey('appVersion', res.data.appVersion)
  setKey('terminal', res.data.terminal)
  // 获取channel
  if ((isAndroid() || isIOS()) && res.data.channel) {
    setKey('appChannel', res.data.channel)
  }

  if (res && res.code === 'OK') {
    // if (res.data.terminal === 'IOS' && !res.data.t && token) {

    // } else {
    //     setKey('userInfo', userInfo)
    // }
    setKey('userInfo', userInfo)
  }
  const isFirstLoginInIosH5 = getKey('FIRST_LOGIN_IN_IOS_H5')
  if (res.data.terminal === 'IOS' && !isFirstLoginInIosH5 && isFirstLoginInIosH5 !== false) {
    setKey('FIRST_LOGIN_IN_IOS_H5', true)
  }
}

export default initJsBridge